import PaintRequestsWorkspace from '../../placeholders/PaintRequestsWorkspace';

export default PaintRequestsWorkspace;
